import { render, staticRenderFns } from "./FAQLink.vue?vue&type=template&id=57b0df95"
import script from "./FAQLink.vue?vue&type=script&lang=ts"
export * from "./FAQLink.vue?vue&type=script&lang=ts"
import style0 from "./FAQLink.vue?vue&type=style&index=0&id=57b0df95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports